export default "__VITE_ASSET__96410b1f__"